import { FormSelector } from "@vesatogo/grass-core"
import { useEffect } from "react"
import { create } from "zustand"
import { persist } from "zustand/middleware"

export type PayableSelectorType = {
  selected: any
  setSelected: (value: any) => void
}

export const usePayableSelector = create<PayableSelectorType>()(
  persist(
    (set, get) => ({
      selected: undefined,
      setSelected(value) {
        set({ selected: value })
      },
    }),
    {
      name: "payable-selector",
    }
  )
)

const selector = [
  { id: "trade", name: "Trade" },
  { id: "receipt", name: "Receipt" },
  { id: "user", name: "User wise" },
]

export const PayableSelector = ({
  disabled,
  withUserWise,
}: {
  disabled?: boolean
  withUserWise?: boolean
}) => {
  const { selected, setSelected } = usePayableSelector()
  const options = withUserWise
    ? selector
    : selector.filter(sel => sel.id !== "user")

  useEffect(() => {
    if (!options.some(opt => opt.id === selected)) {
      setSelected(options?.[0]?.id)
    }
  }, [selected, withUserWise])

  return (
    <FormSelector
      options={options}
      isClearable={false}
      value={options.find(sel => sel.id === selected) || (options?.[0] as any)}
      className={"w-fit"}
      onChange={e => {
        setSelected(e?.id)
      }}
      disabled={disabled}
    />
  )
}
